
import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import BlogHero from './components/BlogHero';
import BlogGrid from './components/BlogGrid';
import BlogCTA from './components/BlogCTA';
import { useSEO, generateWebPageSchema, generateBreadcrumbSchema } from '../../utils/seo';

export default function BlogPage() {
  const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useSEO({
    title: 'Painting & Decorating Blog Watford | Tips & Advice | Brushour',
    description: 'Expert painting and decorating tips, DIY advice, and industry insights from Brushour Watford. Learn about interior painting, exterior painting, and home improvement across Hertfordshire.',
    keywords: 'painting tips Watford, decorating advice Hertfordshire, DIY painting guide, professional painting tips Watford, home improvement Hertfordshire',
    canonical: `${SITE_URL}/blog`,
    schema: [
      generateWebPageSchema('Painting & Decorating Blog – Brushour Watford', 'Expert tips, advice, and insights on painting and decorating for Watford and Hertfordshire homeowners', `${SITE_URL}/blog`),
      generateBreadcrumbSchema([
        { name: 'Home', url: SITE_URL },
        { name: 'Blog', url: `${SITE_URL}/blog` },
      ]),
    ],
  });

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <BlogHero />
      <BlogGrid />
      <BlogCTA />
      <Footer />
    </div>
  );
}
